export default __webpack_public_path__ + "static/media/CT_Art.81ea3cd9.png";